import React, { useState } from 'react';

const ParcelSection = () => {
    const [activeTab, setActiveTab] = useState('client');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <section className="percels-section6 bg1 overflow-visible py-5">
            <div className="container">
                <div className="percels-wrapper n0-bg p-4 p-md-5 rounded-3 shadow-sm">
                    {/* En-tête avec titre */}
                    <div className="text-center mb-4">
                        <h2 className="mb-3">Service d'aide ménagère professionnelle</h2>
                        <p className="text-muted">
                            {activeTab === 'client'
                                ? "Comment trouver l'aide ménagère idéale"
                                : "Comment proposer vos services"}
                        </p>
                    </div>

                    {/* Menu des onglets */}
                    <div className="d-flex flex-column flex-sm-row w-100 gap-2 gap-sm-3 mb-4">
                        <button
                            className={`btn btn-tab flex-grow-1 text-nowrap ${activeTab === 'client' ? 'active' : ''}`}
                            id="client-tab"
                            onClick={() => handleTabClick('client')}
                            type="button"
                            role="tab"
                            style={{
                                padding: '0.75rem 1.5rem',
                                border: '1px solid #dee2e6',
                                borderRadius: '0.5rem',
                                backgroundColor: activeTab === 'client' ? '#116f19' : 'transparent',
                                color: activeTab === 'client' ? 'white' : '#495057',
                                fontWeight: '500',
                                transition: 'all 0.3s ease',
                                fontSize: '0.95rem'
                            }}
                        >
                            <i className="fa-regular fa-user me-2"></i>
                            Je recherche une aide ménagère
                        </button>

                        <button
                            className={`btn btn-tab flex-grow-1 text-nowrap ${activeTab === 'aide' ? 'active' : ''}`}
                            id="aide-tab"
                            onClick={() => handleTabClick('aide')}
                            type="button"
                            role="tab"
                            style={{
                                padding: '0.75rem 1.5rem',
                                border: '1px solid #dee2e6',
                                borderRadius: '0.5rem',
                                backgroundColor: activeTab === 'aide' ? '#116f19' : 'transparent',
                                color: activeTab === 'aide' ? 'white' : '#495057',
                                fontWeight: '500',
                                transition: 'all 0.3s ease',
                                fontSize: '0.95rem'
                            }}
                        >
                            <i className="fa-regular fa-bell-concierge me-2"></i>
                            Je propose mes services
                        </button>
                    </div>

                    {/* Contenu des onglets */}
                    <div className="tab-content n0-bg">
                        {/* Onglet Client - Comment ça marche */}
                        <div
                            className={`tab-pane fade ${activeTab === 'client' ? 'show active' : ''}`}
                            id="client"
                            role="tabpanel"
                            aria-labelledby="client-tab"
                        >
                            <div className="opening-account-wrapper position-relative">
                                <div className="row g-6 justify-content-center">
                                    {/* Étape 1 : Création de compte */}
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="opening-account-item text-center">
                                            <span className="serial-badge m-auto mb-xxl-14 mb-10 d-center rounded-circle">01</span>
                                            <div className="icon rounded-4 d-center m-auto mb-xxl-9 mb-8">
                                                <img src="assets/images/icon/cl-1.png" alt="Création de compte"/>
                                            </div>
                                            <h5 className="n900-clr mb-xxl-4 mb-3 visible-slowly-right">Créez Votre Compte</h5>
                                            <p className="n600-clr fs-seven">
                                                Inscrivez-vous en tant que client en quelques minutes seulement.
                                            </p>
                                        </div>
                                    </div>
                                    {/* Étape 2 : Recherche Profils */}
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="opening-account-item text-center">
                                            <span className="serial-badge m-auto mb-xxl-14 mb-10 d-center rounded-circle">02</span>
                                            <div className="icon rounded-4 d-center m-auto mb-xxl-9 mb-8">
                                                <img src="assets/images/icon/cl-2.png" alt="Recherche de profils"/>
                                            </div>
                                            <h5 className="n900-clr mb-xxl-4 mb-3 visible-slowly-right">Recherchez une Aide</h5>
                                            <p className="n600-clr fs-seven">
                                                Trouvez l'aide ménagère idéale selon vos critères (disponibilité, compétences, localisation).
                                            </p>
                                        </div>
                                    </div>
                                    {/* Étape 3 : Validation Driven Home Services */}
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="opening-account-item text-center">
                                            <span className="serial-badge m-auto mb-xxl-14 mb-10 d-center rounded-circle">03</span>
                                            <div className="icon rounded-4 d-center m-auto mb-xxl-9 mb-8">
                                                <img src="assets/images/icon/cl-3.png" alt="Validation Driven Home Services"/>
                                            </div>
                                            <h5 className="n900-clr mb-xxl-4 mb-3 visible-slowly-right">Validation par Driven Home Services</h5>
                                            <p className="n600-clr fs-seven">
                                                Notre équipe vérifie chaque profil pour garantir qualité et sécurité.
                                            </p>
                                        </div>
                                    </div>
                                    {/* Étape 4 : Mise en relation */}
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="opening-account-item text-center">
                                            <span className="serial-badge m-auto mb-xxl-14 mb-10 d-center rounded-circle">04</span>
                                            <div className="icon rounded-4 d-center m-auto mb-xxl-9 mb-8">
                                                <img src="assets/images/icon/cl-4.png" alt="Mise en relation"/>
                                            </div>
                                            <h5 className="n900-clr mb-xxl-4 mb-3 visible-slowly-right">Mise en Relation</h5>
                                            <p className="n600-clr fs-seven">
                                                Driven Home Services organise la rencontre et facilite les échanges avec l'aide ménagère.
                                            </p>
                                        </div>
                                    </div>
                                    {/* Étape 5 : Contrat et Suivi */}
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="opening-account-item text-center">
                                            <span className="serial-badge m-auto mb-xxl-14 mb-10 d-center rounded-circle">05</span>
                                            <div className="icon rounded-4 d-center m-auto mb-xxl-9 mb-8">
                                                <img src="assets/images/icon/cl-5.png" alt="Contrat et suivi"/>
                                            </div>
                                            <h5 className="n900-clr mb-xxl-4 mb-3 visible-slowly-right">Contrat et Suivi</h5>
                                            <p className="n600-clr fs-seven">
                                                Signature du contrat sécurisé et suivi régulier par Driven Home Services pour votre satisfaction.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Onglet Aide ménagère - Comment ça marche */}
                        <div
                            className={`tab-pane fade ${activeTab === 'aide' ? 'show active' : ''}`}
                            id="aide"
                            role="tabpanel"
                            aria-labelledby="aide-tab"
                        >
                            <div className="opening-account-wrapper position-relative">
                                <div className="row g-6 justify-content-center">
                                    {/* Étape 1 : Création de compte */}
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="opening-account-item text-center">
                                            <span className="serial-badge m-auto mb-xxl-14 mb-10 d-center rounded-circle">01</span>
                                            <div className="icon rounded-4 d-center m-auto mb-xxl-9 mb-8">
                                                <img src="assets/images/icon/pr-1.png" alt="Création de compte"/>
                                            </div>
                                            <h5 className="n900-clr mb-xxl-4 mb-3 visible-slowly-right">Créez Votre Compte</h5>
                                            <p className="n600-clr fs-seven">
                                                Inscrivez-vous en tant qu'aide ménagère en quelques minutes seulement.
                                            </p>
                                        </div>
                                    </div>
                                    {/* Étape 2 : Soumission Profil */}
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="opening-account-item text-center">
                                            <span className="serial-badge m-auto mb-xxl-14 mb-10 d-center rounded-circle">02</span>
                                            <div className="icon rounded-4 d-center m-auto mb-xxl-9 mb-8">
                                                <img src="assets/images/icon/pr-2.png" alt="Soumission de profil"/>
                                            </div>
                                            <h5 className="n900-clr mb-xxl-4 mb-3 visible-slowly-right">Soumettez Votre Profil</h5>
                                            <p className="n600-clr fs-seven">
                                                Complétez votre profil avec vos expériences, disponibilités et documents requis.
                                            </p>
                                        </div>
                                    </div>
                                    {/* Étape 3 : Validation Driven Home Services */}
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="opening-account-item text-center">
                                            <span className="serial-badge m-auto mb-xxl-14 mb-10 d-center rounded-circle">03</span>
                                            <div className="icon rounded-4 d-center m-auto mb-xxl-9 mb-8">
                                                <img src="assets/images/icon/pr-3.png" alt="Validation Driven Home Services"/>
                                            </div>
                                            <h5 className="n900-clr mb-xxl-4 mb-3 visible-slowly-right">Validation par Driven Home Services</h5>
                                            <p className="n600-clr fs-seven">
                                                Notre équipe vérifie votre profil pour garantir qualité et sécurité.
                                            </p>
                                        </div>
                                    </div>
                                    {/* Étape 4 : Mise en relation */}
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="opening-account-item text-center">
                                            <span className="serial-badge m-auto mb-xxl-14 mb-10 d-center rounded-circle">04</span>
                                            <div className="icon rounded-4 d-center m-auto mb-xxl-9 mb-8">
                                                <img src="assets/images/icon/pr-4.png" alt="Mise en relation"/>
                                            </div>
                                            <h5 className="n900-clr mb-xxl-4 mb-3 visible-slowly-right">Mise en Relation</h5>
                                            <p className="n600-clr fs-seven">
                                                Driven Home Services vous met en relation avec des clients correspondant à vos compétences.
                                            </p>
                                        </div>
                                    </div>
                                    {/* Étape 5 : Contrat et Suivi */}
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="opening-account-item text-center">
                                            <span className="serial-badge m-auto mb-xxl-14 mb-10 d-center rounded-circle">05</span>
                                            <div className="icon rounded-4 d-center m-auto mb-xxl-9 mb-8">
                                                <img src="assets/images/icon/pr-5.png" alt="Contrat et suivi"/>
                                            </div>
                                            <h5 className="n900-clr mb-xxl-4 mb-3 visible-slowly-right">Contrat et Suivi</h5>
                                            <p className="n600-clr fs-seven">
                                                Signature du contrat sécurisé et suivi régulier par Driven Home Services.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ParcelSection;